import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './actions';
import * as routes from '../../../routes/const';

import { uniqBy, filter, includes } from 'lodash';
import Header from '../../../components/layouts/Header';

import {
  NitroHeading,
  NitroLoading,
  NitroNavBar,
  NitroGrids,
} from 'nitro-components';
import { KEY_MAKE, KEY_BODY } from './const';

import VehicleFilter from './components/VehicleFilter';
import VehicleCard from './components/VehicleCard';

import styled from 'styled-components';
import { media } from 'style-utils';

const FilterWrapper = styled.div`
  display: flex;
  > * {
    min-width: 200px;
    margin-left: 20px;
    &:first-child {
      margin-left: 0;
    }
  }
`;

const FilterSection = styled.div`
  position: relative;
  margin-bottom: 40px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  ${media.mobileTablet`
    flex-direction: column;
    >* {
      margin: 6px 0;
    }
  `}
`;

const FilterQuantity = styled.span`
  position: relative;
  top: 8px;
  float: left;
  color: ${props => props.theme.color.base3};
`;

class QuoteVehicle extends Component {
  constructor(props, context) {
    super(props, context);

    const filters = {};

    filters[KEY_MAKE] = {
      options: [],
      selected: [],
    };

    filters[KEY_BODY] = {
      options: [],
      selected: [],
    };

    this.state = {
      filters,
      vehicleData: [],
      disabled: true,
      qty: '',
      previousBodyType: '',
    };

    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.createFilterOptions = this.createFilterOptions.bind(this);
    this.applyData = this.applyData.bind(this);
    this.selectVehicle = this.selectVehicle.bind(this);
    this.filter = this.filter.bind(this);
    this.filterData = this.filterData.bind(this);
  }

  componentWillMount() {
    const { updateStep, fetchVehicles } = this.props.actions;

    // remap answers array to remove keys not required by api
    const answers = this.props.answers.map(item => ({
      QuestionId: item.QuestionId,
      Answer: item.Answer,
    }));

    const sessId = this.props.location.query.sessionId;
    console.log('testing sess id', sessId);

    fetchVehicles(sessId);
    updateStep(1);
  }

  componentWillReceiveProps(nextProps) {
    const { router } = this.context;
    const vehicleData = nextProps.vehicles.Vehicles;

    if (nextProps.vehiclesError) {
      // Missing questions, so most likely a page refresh
      if (nextProps.vehiclesError.errors[0].errorCode === 1100) {
        // Redirect to begining
        this.context.router.push(routes.CQ_CREATE);
        return;
      }

      router.push(routes.CQ_CREATE_DECLINED);
    }

    this.createFilterOptions(vehicleData, KEY_BODY);
    this.createFilterOptions(vehicleData, KEY_MAKE);
    this.applyData(vehicleData);
  }

  handleSelectChange(key, selected) {
    // if the cross is clicked to clear the input, selected becomes null. null breaks things. selected must be an array.
    if (selected === null && key === 'BodyType') {
      selected = [];
    }

    const { filters } = this.state;
    filters[key].selected = selected;

    this.setState({ filters });

    this.filterData(this.props.vehicles.Vehicles, key, selected);
  }

  createFilterOptions(array, key) {
    let newArray = uniqBy(array, key);

    let items = newArray.map(item => {
      return {
        value: item[key],
        label: item[key],
      };
    });

    let filters = this.state.filters;

    filters[key].options = items;

    // if there is only one option for make type, show it automatically.
    if (key === KEY_MAKE && newArray.length === 1) {
      filters[KEY_MAKE].selected = [newArray[0].MakeName];
      // set makeName select to enabled
      this.setState({ disabled: true });
    }

    this.setState({ filters });
  }

  createFilterDropdown(key, type, disabled, placeholder) {
    const { filters } = this.state;
    const { selected, options } = filters[key];

    return (
      <VehicleFilter
        placeholder={placeholder}
        type={type}
        name={key}
        selected={selected}
        options={options}
        disabled={disabled}
        onChange={this.handleSelectChange}
      />
    );
  }

  filter(data, matches, key) {
    return filter(data, function(item) {
      return includes(matches, item[key]);
    });
  }

  filterData(data, inputName, selected) {
    const { filters } = this.state;

    // selected body type
    let bodyTypeSelected = [this.state.filters.BodyType.selected.value];

    // clearing input causes undefined array. Reset to empty array
    if (!bodyTypeSelected[0]) {
      bodyTypeSelected = [];
    }

    // array of unique makeNames
    let makeNameSelectedUnique = uniqBy(
      this.state.filters.MakeName.selected,
      'value'
    );

    // array of values from unique makeNames
    let makeNameSelected = makeNameSelectedUnique.map(item => {
      return item.value;
    });

    // if a different bodyType selected, reset the makeType select box
    if (inputName === 'BodyType') {
      if (selected.value !== this.state.previousBodyType) {
        filters[KEY_MAKE].selected = [];
        this.setState({ previousBodyType: selected.value });
      }
    }

    // filtered data using bodyType
    let dataFiltered = this.filter(data, bodyTypeSelected, 'BodyType');

    // options for makeTypes select
    let options = this.filter(data, bodyTypeSelected, 'BodyType');

    // body type selected
    if (bodyTypeSelected.length > 0) {
      // set makeName select to enabled
      this.setState({
        disabled: false,
      });
    } else {
      // reset makeName selected to empty
      filters[KEY_MAKE].selected = [];

      // set makeName select to disabled
      this.setState({
        filters,
        disabled: true,
      });
    }

    // create makeType optons
    this.createFilterOptions(options, KEY_MAKE);

    // makeName selected, filter data further
    if (inputName === KEY_MAKE) {
      if (makeNameSelected.length) {
        dataFiltered = this.filter(dataFiltered, makeNameSelected, KEY_MAKE);
      }
    }

    this.setState({
      // set qty for results
      qty: dataFiltered.length < 1 ? data.length : dataFiltered.length,
      // set data fro vehicle list
      vehicleData: dataFiltered.length < 1 ? data : dataFiltered,
    });
  }

  applyData(data) {
    this.setState({
      qty: data.length,
      vehicleData: data,
    });
  }

  selectVehicle(vehicle, terms) {
    const { selectVehicle } = this.props.actions;

    selectVehicle(vehicle, terms);

    const { router } = this.context;
    router.push(routes.CQ_CREATE_OPTIONS);
  }

  render() {
    const vehicleData = this.state.vehicleData;
    const answerData = this.props.answers;

    // show loader while waiting
    if (vehicleData.length < 1) return <NitroLoading screen />;

    let vehicleList = vehicleData.map((item, index) => {
      return (
        <VehicleCard vehicle={item} action={this.selectVehicle} key={index} />
      );
    });

    return (
      <section>
        <Header margin="32px 0" lineHeight={32}>
          {answerData.length ? (
            <NitroNavBar
              actionOnHeading
              label="Back to questions"
              action={() =>
                this.context.router.push(routes.CQ_CREATE_QUESTIONS)
              }
              inline
              noPadding
              float
              lineHeight={26}
            />
          ) : null}
          <NitroHeading label="Select a vehicle" size="1" align="center" />
        </Header>

        <FilterSection>
          <FilterQuantity>{this.state.qty} results</FilterQuantity>
          <FilterWrapper>
            {this.createFilterDropdown(
              KEY_BODY,
              false,
              false,
              'Select body type'
            )}
            {this.createFilterDropdown(
              KEY_MAKE,
              true,
              this.state.disabled,
              'Select make'
            )}
          </FilterWrapper>
        </FilterSection>

        <NitroGrids>{vehicleList}</NitroGrids>
      </section>
    );
  }
}

QuoteVehicle.propTypes = {
  answers: PropTypes.array.isRequired,
  vehicles: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  vehiclesError: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

QuoteVehicle.contextTypes = {
  router: PropTypes.object,
};

const mapStateToProps = state => {
  const { create } = state.corporateQuote;

  return {
    vehicles: create.vehicles,
    answers: create.answers,
    vehiclesError: create.fetchingVehiclesError,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuoteVehicle);



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/QuoteVehicle.js